export default __webpack_public_path__ + "static/media/10.8575d5a9.jpg";